<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==1">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="mainpage.startTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="mainpage.endTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称或编号：</div>
          <el-input v-model="mainpage.form.sn" placeholder="设备名称或编号" style="width: 250px;"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备类型：</div>
          <el-select v-model="mainpage.form.devtype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.devtype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleMainSearch">查询</el-button>
        </div>
      </div>
      <div class="data-display flex-column flex-justify-start flex-align-center">
        <div class="data-bs">
          <el-button type="success" icon="el-icon-plus" style="font-size: 14px; padding: 11px;margin-left: 20px;" @click="changeSubindex(2)">新增</el-button>
        </div>
        <div class="gird-area flex-row flex-justify-start flex-align-start">
          <el-table :data="mainpage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="devtype" label="设备类型"></el-table-column>
            <el-table-column prop="location" label="安装位置" width="300"></el-table-column>
            <el-table-column prop="submituser" label="申报人"></el-table-column>
            <el-table-column prop="submitdate" label="申报时间"></el-table-column>
            <el-table-column label="故障图片" width="100">
              <template slot-scope="scope">
                <el-image style="width: 20px; height: 20px" :src="scope.row.errimg" :preview-src-list="[scope.row.errimg]" v-if="scope.row.errimg"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="errlog" label="故障说明"></el-table-column>
            <el-table-column label="解决状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.state == '已解决'">{{ scope.row.state }}</el-tag>
                <el-tag type="danger" v-else>{{ scope.row.state }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="repairlog" label="解决说明"></el-table-column>
            <el-table-column label="解决图片" width="100">
              <template slot-scope="scope">
                <el-image style="width: 20px; height: 20px" :src="scope.row.repairimg" :preview-src-list="[scope.row.repairimg]" v-if="scope.row.repairimg"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="repairuser" label="解决人"></el-table-column>
            <el-table-column prop="repairdate" label="解决时间"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="查看" placement="top-start">
                  <i class="el-icon-document" @click="handleView(scope.row)" style="cursor: pointer; font-size: 18px;"></i>
                </el-tooltip>
                <el-tooltip effect="light" content="维修" placement="top-start">
                  <i class="el-icon-edit" @click="handleEdit(scope.row)" style="cursor: pointer; font-size: 18px; margin-left: 5px;"></i>
                </el-tooltip>
                <el-tooltip effect="light" content="删除" placement="top-start">
                  <i class="el-icon-delete" @click="handleDel(scope.row)" style="cursor: pointer; font-size: 18px; margin-left: 5px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="mainpage.form.totalpage"
            :current-page.sync="mainpage.form.currpage"
            :page-size="mainpage.form.pagesize"
            @current-change="handleMainPage">
          </el-pagination>
        </div>
      </div>
      <el-dialog
        title="维修登记"
        :visible.sync="mainpage.weixiudialog"
        width="30%"
        style="text-align: left;">
        <el-form label-position="right" label-width="150px">
          <el-form-item label="解决说明：">
            <el-input type="textarea" :rows="4" v-model="weixiupage.form.repairlog" style="width: 70%;"></el-input>
          </el-form-item>
          <el-form-item label="解决图片：">
            <el-upload class="errimgup" :action="''" :auto-upload="false" :show-file-list="false" accept="image/*" :on-change="handleRepairimgChange">
              <img :src="weixiupage.form.repairimgUrl" alt="" class="errimg" v-if="weixiupage.form.repairimgUrl">
              <i class="el-icon-plus repairimgup-icon" v-else></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="解决人：">
            <el-input v-model="weixiupage.form.repairuser" style="width: 70%;"></el-input>
          </el-form-item>
          <el-form-item label="解决时间：">
            <el-date-picker
              v-model="weixiupage.repairdate"
              type="datetime"
              placeholder="选择时间"
              style="width: 70%">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="mainpage.weixiudialog = false">取 消</el-button>
          <el-button type="primary" @click="handleEditSave">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="删除"
        :visible.sync="mainpage.deldialog"
        width="30%"
        style="text-align: left;">
        <span>确认删除？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="mainpage.deldialog = false">取 消</el-button>
          <el-button type="primary" @click="handleDelConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==2">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">新增维修记录</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备编号：">
              <el-input v-model="addpage.form.sn" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：">
              <el-input v-model="addpage.form.name" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备类型：">
              <el-input v-model="addpage.form.devtype" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="安装位置：">
              <el-input v-model="addpage.form.location" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="故障说明：">
              <el-input type="textarea" :rows="4" v-model="addpage.form.errlog" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="故障图片：">
              <el-upload class="errimgup" :action="''" :auto-upload="false" :show-file-list="false" accept="image/*" :on-change="handleErrimgChange">
                <img :src="addpage.form.errimgUrl" alt="" class="errimg" v-if="addpage.form.errimgUrl">
                <i class="el-icon-plus errimgup-icon" v-else></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="申报人：">
              <el-input v-model="addpage.form.submituser" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="申报时间：">
              <el-input v-model="addpage.form.submitdate" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align: right;width: 100%;">
                <el-button type="primary" @click="handleAddRepair">保存</el-button>
                <el-button type="primary" @click="changeSubindex(1)">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" style="font-size: 14px; padding: 11px;margin-left: 20px;" @click="changeSubindex(3)">选择报修设备</el-button>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==3">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">选择报修设备</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(2)"></i>
        </div>
      </div>
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="shebeipage.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in shebeipage.options.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="shebeipage.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in shebeipage.options.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="shebeipage.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in shebeipage.options.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">抄表类型：</div>
          <el-select v-model="shebeipage.form.devtype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.devtype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称或编号：</div>
          <el-input v-model="shebeipage.form.sn" placeholder="设备名称或编号" style="width: 250px;"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleShebeiSearch">查询</el-button>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center" style="margin-top: 20px;">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-table :data="shebeipage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="devtype" label="设备类型"></el-table-column>
            <el-table-column prop="location" label="安装位置"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="选择设备" placement="top-start">
                  <i class="el-icon-check" @click="handleCheck(scope.row)" style="cursor: pointer; font-size: 18px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="shebeipage.form.totalpage"
            :current-page.sync="shebeipage.form.currpage"
            :page-size="shebeipage.form.pagesize"
            @current-change="handleShebeiPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==4">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">查看</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备编号：">
              <el-input readonly v-model="viewpage.form.sn" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：">
              <el-input readonly v-model="viewpage.form.name" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备类型：">
              <el-input readonly v-model="viewpage.form.devtype" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="安装位置：">
              <el-input readonly v-model="viewpage.form.location" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="故障说明：">
              <el-input readonly type="textarea" :rows="4" v-model="viewpage.form.errlog" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="故障图片：">
              <div style="width: 120px;height: 120px;border: 1px dashed #d9d9d9;border-radius: 6px;">
                <img :src="viewpage.form.errimgUrl" alt="" class="errimg" v-if="viewpage.form.errimgUrl">
                <i class="errimgup-icon" v-else></i>
              </div>
            </el-form-item>
            <el-form-item label="申报人：">
              <el-input readonly v-model="viewpage.form.submituser" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="申报时间：">
              <el-input readonly v-model="viewpage.form.submitdate" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="解决状态：">
              <el-input readonly v-model="viewpage.form.state" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="解决说明：">
              <el-input readonly v-model="viewpage.form.repairlog" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="解决图片：">
              <div style="width: 120px;height: 120px;border: 1px dashed #d9d9d9;border-radius: 6px;">
                <img :src="viewpage.form.repairimgUrl" alt="" class="errimg" v-if="viewpage.form.repairimgUrl">
                <i class="errimgup-icon" v-else></i>
              </div>
            </el-form-item>
            <el-form-item label="解决人：">
              <el-input readonly v-model="viewpage.form.repairuser" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="解决时间：">
              <el-input readonly v-model="viewpage.form.repairdate" style="width: 600px;"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import {getChangqu, getLouhao, getLouCeng, getRepairList, getMeterList, addRepair, editRepair, delRepair} from '@/api/engery.js'
export default {
  name: 'EngeryRepair',
  data() {
    return {
      subindex: 1,
      lastsubindex: 1,
      mainpage: {
        weixiudialog: false,
        deldialog: false,
        form: {
          startTime: '',
          endTime: '',
          sn: '',
          devtype: '全部',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        startTime: null,
        endTime: null,
        tableData: [],
        options: {
          devtype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
        }
      },
      weixiupage: {
        form: {
          repairlog: '',
          repairimgUrl: '',
          repairimg: null,
          repairuser: '',
          repairdate: ''
        },
        repairdate: null,
        row: {}
      },
      addpage: {
        form: {
          sn: '',
          name: '',
          devtype: '',
          location: '',
          errlog: '',
          errimgUrl: '',
          errimg: null,
          submituser: '',
          submitdate: ''
        },
        row: {}
      },
      viewpage: {
        form: {
          sn: '',
          name: '',
          devtype: '',
          location: '',
          errlog: '',
          errimgUrl: '',
          submituser: '',
          submitdate: '',
          state: '',
          repairlog: '',
          repairimgUrl: '',
          repairuser: '',
          repairdate: ''
        }
      },
      shebeipage: {
        form: {
          changqu: '全部',
          louhao: '',
          louceng: '',
          devtype: '全部',
          sn: '',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        options: {
          changqu: [],
          louhao: [],
          louceng: []
        },
        tableData: []
      },
      delpage: {
        row: {}
      }
    }
  },
  async mounted() {
    const changqulist = await getChangqu()
    this.shebeipage.options.changqu = changqulist.data
    const repairList = await getRepairList(this.mainpage.form)
    this.mainpage.tableData = repairList.data
  },
  computed: {
    ...mapGetters([
      'getUserInfo'
    ])
  },
  methods: {
    async handleShebeiPage(value) {
      const response = await getMeterList(this.shebeipage.form)
      this.shebeipage.tableData = response.data
      this.shebeipage.form.totalpage = response.totalpage
    },
    async handleMainPage(value) {

    },
    async handleShebeiSearch() {
      const response = await getMeterList(this.shebeipage.form)
      this.shebeipage.tableData = response.data
      this.shebeipage.form.totalpage = response.totalpage
    },
    handleCheck(param) {
      this.addpage.form.sn = param.sn
      this.addpage.form.name = param.name
      this.addpage.form.devtype = param.devtype
      this.addpage.form.location = param.location
      this.addpage.row = param
      this.changeSubindex(2)
    },
    async handleAddRepair() {
      if(this.addpage.form.sn == '') {
        this.$message.error('请选择表具')
        return
      }
      if(this.addpage.form.errlog == '') {
        this.$message.error('故障说明不能为空')
        return
      }
      if(this.addpage.form.errimgUrl == '') {
        this.$message.error('故障图片不能为空')
        return
      }
      const formData = new FormData()
      formData.append('meter_id', this.addpage.row.iid)
      formData.append('resolve_state', false)
      formData.append('declare_person', this.addpage.form.submituser)
      formData.append('declare_time', this.addpage.form.submitdate)
      formData.append('fault_instruction', this.addpage.form.errlog)
      formData.append('fault_photo', this.addpage.form.errimg, 'fault_photo.jpg')
      const result = await addRepair(formData)
      if(result.id) {
        this.$message.success('添加维修记录成功')
        this.changeSubindex(1)
        await this.handleMainSearch()
      } else {
        this.$message.error('添加维修记录失败')
      }
    },
    async handleChangqu(value) {
      this.shebeipage.form.louhao = ''
      this.shebeipage.options.louhao = []
      this.shebeipage.form.louceng = ''
      this.shebeipage.options.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.shebeipage.options.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouhao(result[0].park_id)
      if(response.data.length <= 1) {
        this.shebeipage.form.louhao = ''
        this.shebeipage.options.louhao = []
        this.shebeipage.form.louceng = ''
        this.shebeipage.options.louceng = []
        return
      }
      this.shebeipage.options.louhao = response.data
      if(this.shebeipage.options.louhao.length > 0) {
        this.shebeipage.form.louhao = this.shebeipage.options.louhao[0].value
      }
    },
    async handleLouhao(value) {
      this.shebeipage.form.louceng = ''
      this.shebeipage.options.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.shebeipage.options.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouCeng(result[0].building_id)
      if(response.data.length <= 1) {
        this.shebeipage.form.louceng = ''
        this.shebeipage.options.louceng = []
        return
      }
      this.shebeipage.options.louceng = response.data
      if(this.shebeipage.options.louceng.length > 0) {
        this.shebeipage.form.louceng = this.shebeipage.options.louhao[0].value
      }
    },
    formatDateTime(now) {
      const padZero = n => n < 10 ? `0${n}` : n
      const year = now.getFullYear()
      const month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    async changeSubindex(index) {
      this.lastsubindex = this.subindex
      this.subindex = index
      if(index == 2 && this.lastsubindex == 1) {
        this.addpage.form.sn = ''
        this.addpage.form.name = ''
        this.addpage.form.devtype = ''
        this.addpage.form.location = ''
        this.addpage.form.errlog = ''
        this.addpage.form.errimgUrl = ''
        const userInfo = this.getUserInfo
        this.addpage.form.submituser = userInfo.username
        const datetime = this.formatDateTime(new Date())
        this.addpage.form.submitdate = datetime.replace(/ /g, 'T')
      }
      else if(index == 3) {
        const response = await getMeterList(this.shebeipage.form)
        this.shebeipage.tableData = response.data
        this.shebeipage.form.totalpage = response.totalpage
      }
    },
    async handleMainSearch() {
      if(this.mainpage.startTime != null) {
        const startTime = this.formatDateTime(this.mainpage.startTime, 0)
        this.mainpage.form.startTime = startTime.substr(0, 10)
      }
      if(this.mainpage.endTime != null) {
        const endTime = this.formatDateTime(this.mainpage.endTime, 0)
        this.mainpage.form.endTime = endTime.substr(0, 10)
      }
      const repairList = await getRepairList(this.mainpage.form)
      this.mainpage.tableData = repairList.data
    },
    handleView(param) {
      this.changeSubindex(4)
      this.viewpage.form.sn = param.sn
      this.viewpage.form.name = param.name
      this.viewpage.form.devtype = param.devtype
      this.viewpage.form.location = param.location
      this.viewpage.form.errlog = param.errlog
      this.viewpage.form.errimgUrl = param.errimg
      this.viewpage.form.submituser = param.submituser
      this.viewpage.form.submitdate = param.submitdate
      this.viewpage.form.state = param.state
      this.viewpage.form.repairlog = param.repairlog
      this.viewpage.form.repairimgUrl = param.repairimg
      this.viewpage.form.repairuser = param.repairuser
      this.viewpage.form.repairdate = param.repairdate
    },
    handleEdit(param) {
      this.mainpage.weixiudialog = true
      this.weixiupage.row = param
      this.weixiupage.form.repairimg = null
      this.weixiupage.form.repairlog = param.repairlog
      this.weixiupage.form.repairimgUrl = ''
      this.weixiupage.form.repairuser = param.repairuser
      this.weixiupage.form.repairdate = param.repairdate
    },
    async handleEditSave() {
      if(this.weixiupage.form.repairlog == '') {
        this.$message.error('解决说明不能为空')
        return
      }
      if(this.weixiupage.form.repairimgUrl == '') {
        this.$message.error('故障图片不能为空')
        return
      }
      if(this.weixiupage.form.repairuser == '') {
        this.$message.error('解决人不能为空')
        return
      }
      if(this.weixiupage.repairdate == null) {
        this.$message.error('解决时间不能为空')
        return
      }
      const repairdate = this.formatDateTime(this.weixiupage.repairdate, 0)
      this.weixiupage.form.repairdate = repairdate.replace(/ /g, 'T')
      const formData = new FormData()
      formData.append('meter_id', this.weixiupage.row.iid)
      formData.append('resolve_state', true)
      formData.append('resolve_instruction', this.weixiupage.form.repairlog)
      formData.append('resolve_person', this.weixiupage.form.repairuser)
      formData.append('resolve_time', this.weixiupage.form.repairdate)
      formData.append('resolve_photo', this.weixiupage.form.repairimg, 'resolve_photo.jpg')
      const result = await editRepair(this.weixiupage.row.iid, formData)
      if(result.id) {
        this.$message.success('编辑维修记录成功')
        this.mainpage.weixiudialog = false
        await this.handleMainSearch()
      } else {
        this.$message.error('编辑维修记录失败')
      }
    },
    formatDateTime(now) {
      const padZero = n => n < 10 ? `0${n}` : n
      const year = now.getFullYear()
      const month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    handleDel(param) {
      this.mainpage.deldialog = true
      this.delpage.row = param
    },
    async handleDelConfirm() {
      await delRepair(this.delpage.row.iid)
      this.$message.success('删除维修记录成功')
      await this.handleMainSearch()
      this.mainpage.deldialog = false
    },
    handleErrimgChange(file) {
      this.addpage.form.errimg = file.raw
      this.addpage.form.errimgUrl = URL.createObjectURL(file.raw)
    },
    handleRepairimgChange(file) {
      this.weixiupage.form.repairimg = file.raw
      this.weixiupage.form.repairimgUrl = URL.createObjectURL(file.raw)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.data-sample {
  width: 99%;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.data-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.data-bs {
  width: 100%;
  margin-top: 20px;
  text-align: left;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.hhead {
  width: 100%;
  font-family: 'Arial';
  font-size: 16px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding: 10px;
}
.hheadl {
  width: 50%;
  margin-left: 10px;
}
.hheadr {
  width: 50%;
  margin-right: 10px;
}
.luru-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.4);
  padding-bottom: 20px;
}
.errimgup {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.errimgup:hover {
  border-color: #409EFF;
}
.errimgup-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 120px;
  text-align: center;
}
.repairimgup-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.errimg {
  width: 120px;
  height: 120px;
  display: block;
}
.data-page {
  width: 98%;
}
</style>
